import { createReducer } from "@reduxjs/toolkit";
import {
  FORM_RULES_LOADING,
  GET_FORM_RULES,
  FORM_RULES_ERROR,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const formRulesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(FORM_RULES_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(FORM_RULES_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(GET_FORM_RULES, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default formRulesReducer;
